<template>
	<v-snackbar
		v-for="(notify, index) in appNotifications"
		:key="`notify-${index}`"
		v-model="notify.status"
		:timeout="notify.timeout || 2000"
		:color="notify.color"
		:location="'top right'"
	>
		<div
			:style="notify.text.length > 1200 ? 'font-size: 8px;' : ''"
		>
			{{ notify.text }}
		</div>

		<template v-slot:actions>
			<v-btn
				color="blue"
				variant="text"
				@click="notify.status = false"
			>
				{{ $t('Close') }}
			</v-btn>
		</template>
	</v-snackbar>
</template>
<script>
import { useApplicationStore } from '@/stores/applicationStore'
import { mapState } from 'pinia'
export default {
	computed: {
		...mapState(useApplicationStore, [
			'appNotifications'
		]),
	}
}
</script>
